import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['mainOccupation', 'subOccupation', 'errorMainSelect', 'errorSubSelect', 'submitButton'];

  connect() {
    // sub_occupation_optionsのデータを取得
    const subOccupationData = this.subOccupationTarget.dataset.occupationSubOccupationOptions;
    this.subOccupationOptions = subOccupationData ? JSON.parse(subOccupationData) : {};

    this.setSubOccupationOptions();
    this.controllSubmitButton();
  }

  setSubOccupationOptions() {
    const selectedMainOccupation = this.mainOccupationTarget.value;
    const selectedSubOccupation = this.subOccupationTarget.dataset.selectedSubOccupation;
    this.subOccupationTarget.innerHTML = '';

    const blankOption = document.createElement('option');
    blankOption.value = '';
    blankOption.textContent = '職種を選択してください';
    this.subOccupationTarget.appendChild(blankOption);

    if (selectedMainOccupation && this.subOccupationOptions[selectedMainOccupation]) {
      this.subOccupationOptions[selectedMainOccupation].forEach(sub => {
        const option = document.createElement('option');
        option.value = sub;
        option.textContent = sub;

        // 選択済みのsub_occupationがあれば選択状態にする
        if (selectedSubOccupation === sub) {
          option.selected = true;
        }

        this.subOccupationTarget.appendChild(option);
      });

      this.subOccupationTarget.disabled = false;
    } else {
      this.subOccupationTarget.disabled = true;
    }
  } 

  validateMainOccupation() {
    const isMainInvalid = this.mainOccupationTarget.value == '';
    this.mainOccupationTarget.classList.toggle('regist_form__error_input', isMainInvalid)
    this.errorMainSelectTarget.classList.toggle('regist_form__hide', !isMainInvalid);
  }

  validateSubOccupation() {
    const isSubInvalid = this.subOccupationTarget.value == '';
    this.subOccupationTarget.classList.toggle('regist_form__error_input', isSubInvalid)
    this.errorSubSelectTarget.classList.toggle('regist_form__hide', !isSubInvalid);
  }

  controllSubmitButton() {
    const isMainInvalid = this.mainOccupationTarget.value == '';
    const isSubInvalid = this.subOccupationTarget.value == '';

    const isFormInvalid = isMainInvalid || isSubInvalid;
    this.submitButtonTarget.disabled = isFormInvalid;
    this.submitButtonTarget.classList.toggle('regist_form__button--disabled', isFormInvalid);
  }
}
